(() => {
  const init = () => {
    const landing = document.querySelector('[data-blanks-product-landing]');
    const mainSection = document.querySelector('.main-product-section');
    if (!landing || !mainSection || landing.dataset.initialized === 'true') return;

    landing.dataset.initialized = 'true';
    document.body.classList.add('blanks-sticky-enabled');

    const mainButton = mainSection.querySelector('.product-form__submit');
    const variantArea = mainSection.querySelector('variant-radios, variant-selects, .product-form__input');
    const sticky = landing.querySelector('[data-blp-sticky]');
    const stickyButton = landing.querySelector('[data-blp-sticky-button]');
    const stickyPrice = landing.querySelector('[data-blp-sticky-price]');
    const finalButton = landing.querySelector('[data-blp-scroll-to-buy]');

    const scrollToBuy = () => {
      (variantArea || mainButton || mainSection).scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const syncSticky = () => {
      if (!mainButton || !stickyButton) return;
      stickyButton.disabled = mainButton.disabled;
      const sourceLabel = mainButton.querySelector('span');
      stickyButton.textContent = sourceLabel?.textContent?.trim() || (mainButton.disabled ? 'Sold out' : 'Add to cart');

      const activePrice = mainSection.querySelector('.price--on-sale .price-item--sale, .price__regular .price-item--regular');
      if (activePrice && stickyPrice) stickyPrice.textContent = activePrice.textContent.trim();
    };

    finalButton?.addEventListener('click', scrollToBuy);

    stickyButton?.addEventListener('click', () => {
      if (!mainButton || mainButton.disabled) {
        scrollToBuy();
        return;
      }
      mainButton.click();
    });

    mainSection.addEventListener('change', () => window.setTimeout(syncSticky, 100));

    if (mainButton) {
      new MutationObserver(syncSticky).observe(mainButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-hidden', entry.isIntersecting);
        }, { threshold: 0.2 }).observe(mainButton);
      }
    }

    syncSticky();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
